import CalendarLocale from '../calendar/pl_PL';
import TimePickerLocale from '../time-picker/pl_PL';

// Merge into a locale object
const locale = {
  lang: {
    placeholder: 'Wybierz datÄ',
    rangePlaceholder: ['Data poczÄtkowa', 'Data koÅcowa'],
    ...CalendarLocale,
  },
  timePickerLocale: {
    ...TimePickerLocale,
  },
};

// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

export default locale;
